<template>
  <b-modal
    :visible="visible"
    size="xl"
    hide-footer
    header-class="align-items-center"
    @hide="$emit('close')"
    @hidden="clearData"
  >
    <template slot="modal-header">
      <h2 class="v2_font_size_20">Society Test Email</h2>
      <div>
        <b-button variant="primary" :disabled="isButtonDisabled" @click="send">
          <template v-if="!sendLoading">Send</template>
          <b-spinner v-else small />
        </b-button>
        <b-button variant="default" @click="$emit('close')">
          Cancel
        </b-button>
      </div>
    </template>

    <v-wait :visible="loading" :for="$options.name">
      <template slot="waiting">
        <HalfCircleSpinner />
        <div class="spinner-message my-3 text-center">
          Getting society data...
        </div>
      </template>
      <template>
        <b-form-group
          label="Destination email address:"
          label-cols-sm="3"
          label-align-sm="left"
          class="mb-0 pt-3"
        >
          <b-form-input
            type="email"
            v-model="email"
            :state="validateState('email')"
          />
          <b-form-invalid-feedback :state="validateState('email')">
            {{ emailInvalidFeedback }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Email Type:"
          label-cols-sm="3"
          label-align-sm="left"
          class="mb-0 pt-2"
        >
          <b-form-select
            :options="typeOptions"
            v-model="type"
            stacked
            :state="validateState('type')"
          />
          <b-form-invalid-feedback :state="validateState('type')">
            {{ invalidFeedback }}
          </b-form-invalid-feedback>
        </b-form-group>
      </template>
    </v-wait>
  </b-modal>
</template>

<script>
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { HalfCircleSpinner } from 'epic-spinners';
import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';
import validateStateMixin from '@/mixins/validateStateMixin';
import { DYNAMIC_CONTENT_EMAIL_TYPE_OPTIONS } from '@/store';

export default {
  name: 'TestEmailModal',
  mixins: [validationMixin, validateStateMixin],
  components: {
    HalfCircleSpinner,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    societyId: {
      type: Number,
      required: true,
    },
  },
  data: function () {
    return {
      sendLoading: false,
      sendTestLoading: false,
      loading: false,
      type: null,
      email: null,
    };
  },
  validations: {
    type: {
      required,
    },
    email: {
      required,
      email,
    },
  },
  computed: {
    typeOptions: function () {
      return DYNAMIC_CONTENT_EMAIL_TYPE_OPTIONS;
    },
    isButtonDisabled: function () {
      return !!this.sendLoading || !!this.loading;
    },
    invalidFeedback: function () {
      return 'This field is required';
    },
    emailInvalidFeedback: function () {
      return !this.$v.email.email
        ? 'Test Address Email should be a valid email.'
        : 'This field is required';
    },
  },
  methods: {
    send: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      this.sendLoading = true;
      try {
        const data = {
          societyId: this.societyId,
          type: this.type,
          email: this.email,
        };
        await Api.sendTestEmail(data);
        this.$toasted.success('Test Email sent successfully.', {
          duration: 3000,
        });
      } catch (e) {
        handleServerErrorWithValidation(e, this.$toasted);
      } finally {
        this.sendLoading = false;
        this.$v.$reset();
      }
    },
    clearData: function () {
      this.type = null;
      this.email = null;
      this.$v.$reset();
    },
  },
};
</script>

<style scoped />
